import React from 'react'

const HorizontalLine = ({ name = 'Settings' }) => {
  return (
    <div className="settings-section-divider flex items-center w-full my-10">
      <hr className="flex-grow border-t-2 border-black mr-2" />
      <p className="settings-section-title text-3xl font-bold text-black">{name}</p>
      <hr className="flex-grow border-t-2 border-black ml-2" />
    </div>
  )
}

export default HorizontalLine




export const HorizontalLineFull = () => {
  return (
    <div className="settings-section-divider-full flex items-center w-full my-10">
      <hr className="flex-grow border-t-2 border-black mr-2" />
    </div>
  )
}
